<template>
<div>
  <div class="row">
  <div class="px-3 col-12 pb-4">
    <GmapMap
        :center='center'
        :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUi: false,
                      }"
        :zoom='9'
        style='width:100%;  height: 400px;'>
      <GmapMarker
          v-for="(m, index) in markers"
          :key="index"
          :position="m.position"
          @click="markerClick(m.vendorID,m.name,m.description,m.date)"
      />
    </GmapMap>
  </div>
  </div>

  <v-bottom-sheet v-model="vendorDetailModal" class="bottom-sheet" width="600">
    <v-sheet
        v-if="isDetailLoaded"
        class="rounded-t-xl">
      <div class="row no-gutters align-items-center">
        <div class="col-auto pr-5 py-2 toggle-filter-btn">
          {{ name }} فروشگاه
        </div>
        <div class="col text-left pl-4">
          <v-btn
              icon
              @click="vendorDetailModal = !vendorDetailModal">
           <span class="fa-stack font16px bottom-sheet">
             <i class="fa-solid fa-clock-seven fa-stack-2x black--text"></i>
             <i class="fa-solid fa-circle-xmark fa-stack-1x fa-inverse white--text"></i>
           </span>
          </v-btn>
        </div>
      </div>
      <div class="row mx-2">
        <div class="col-12">
          <div class="border-bottom" v-html="description"></div>
          <div class="border-bottom py-2"> {{ $convertDate(date) }}</div>
        </div>
        <div class="col-12 text-left">
          <v-btn color="primary" class="white--text" rounded :to="{path:'StoreProfile',query:{VendorID:id}}">
            مشاهده
          </v-btn>
        </div>
      </div>

    </v-sheet>
  </v-bottom-sheet>
</div>
</template>

<script>
export default {
  name: "PaymentsHomesMap",
  props:['markers'],
  data: () => ({
    vendorDetailModal: false,
    searchKeyWord: null,
    center: {lat: 35.699936, lng: 51.390377},
    text: "",
    currentPlace: null,
    date: null,
    description: null,
    name: null,
    id: null,
    isDetailLoaded: false,
  }),
  methods:{
    markerClick(id, name, desc, date) {
      this.vendorDetailModal = true
      this.id = id;
      this.name = name;
      this.description = desc;
      this.date = date
      this.isDetailLoaded = true
    }
  }
}
</script>

<style scoped>

</style>